// @flow
import React, { Component, PropTypes } from 'react';
import { connect } from 'react-redux';
import FileSaver from 'file-saver';
import _ from 'lodash';
import Config from 'config';
import { ResourceGeneratorParams } from './ResourceGeneratorParams';
import type { ResourceGenerateRequest } from '../../types/resource';
import { generateResources, resetResultantCohorts } from '../../actions/app';
import { downloadCohortYaml } from '../../actions/cohorts';
import type { Errors } from '../../types/errors';
import { resetErrorState } from '../../actions/helpers';
import CitiesObject from '../autosim/simulation/cities';
import { ResourceGeneratorOutput } from './ResourceGeneratorOutput';

import handleCohortEvent from '../dashboard/cohort-events-handler';

type Props = {
  generateResources: Function,
  generateResourcesErrors: Errors,
  resetErrorState: Function,
  resultantCohortIDs: ?Array<any>,
  resetResultantCohorts: Function,
  cohortStatus: ?Array<any>,
  downloadCohortYaml: Function,
  cohortYamlFile: string,
};

export class ResourceGeneratorContainer extends Component {

  static contextTypes = {
    store: PropTypes.object,
  };

  constructor(props: Props) {
    super(props);
    this.state = {
      cohortName: null,
      paxVal: 0,
      daxVal: 0,
      cityCode: 'CITY_SG_SIN',
      cohortType: '0',
      disabledInputs: false,
      cities: new CitiesObject().cities,

      downloadCohortID: null,
    };
    this.cohortSocket = null;
  }

  componentDidUpdate(prevProps: Props) {
    const successCohortID: boolean = !_.isEqual(prevProps.resultantCohortIDs, this.props.resultantCohortIDs) &&
      this.props.resultantCohortIDs.length > 0;
    if (successCohortID) {
      this.connectActiveCohortSocket();
    }
    const successCohortYamlFile: boolean = !_.isEqual(prevProps.cohortYamlFile, this.props.cohortYamlFile) &&
        this.props.cohortYamlFile;
    if (successCohortYamlFile) {
      const blob = new Blob([this.props.cohortYamlFile], { type: 'text/plain;charset=utf-8' });
      FileSaver.saveAs(blob, `${this.state.downloadCohortID}-cohort-yaml.txt`);
    }
  }

  componentWillUnmount() {
    this.props.resetResultantCohorts();
  }

  connectActiveCohortSocket() {
    if (this.cohortSocket) {
      this.cohortSocket.close();
    }
    const cohortID: string = this.props.resultantCohortIDs;
    const cohortSocket = new WebSocket(`${Config.WEBSOCKET_BASE_URL}/cohorts/${cohortID}/events`);

    cohortSocket.onmessage = (event: any) => {
      const action = handleCohortEvent(cohortID, JSON.parse(event.data));
      this.context.store.dispatch(action);
    };
    cohortSocket.onclose = (event: any) => {
      if (this.cohortSocket !== cohortSocket) {
        return;
      }
      this.setState({
        cohortDisconnectionCode: event.code,
      });
      this.disconnectActiveCohortSocket();
    };
    this.cohortSocket = cohortSocket;
  }

  disconnectActiveCohortSocket() {
    if (this.cohortSocket) {
      this.cohortSocket.onclose = null;
      this.cohortSocket.close();
      this.cohortSocket = null;
    }
  }

  fillCity = () => {
    const cityArr = [];
    const cities = this.state.cities;
    for (let i = 0; i < cities.length; i += 1) {
      const cityCode = cities[i].city_code;

      cityArr.push(<option
        key={cities[i].name}
        value={cityCode}
      >{cities[i].name}
      </option>);
    }
    return cityArr;
  };

  handleCohortNameChange = (event: Event) => {
    const cohortName = (event.target: window.HTMLInputElement).value;
    this.setState({
      cohortName,
    });
  };

  handleCityChange = (event: Event) => {
    const city = (event.target: window.HTMLInputElement).value;
    this.setState({
      cityCode: city,
    });
  };

  handleNumPaxChange = (paxVal: Number) => {
    this.setState({ paxVal });
  };

  handleNumDaxChange = (daxVal: Number) => {
    this.setState({ daxVal });
  };

  handleCohortTypeChange = (event: Event) => {
    this.setState({ cohortType: (event.target: window.HTMLInputElement).value });
  };

  startGenerateResources = () => {
    const request: ResourceGenerateRequest = {
      name: this.state.cohortName,
      numPassengers: parseInt(this.state.paxVal, 10),
      numDrivers: parseInt(this.state.daxVal, 10),
      cityCode: this.state.cityCode,
      shortLived: this.state.cohortType,
    };
    this.props.generateResources(request);
  };

  downloadCohortYaml = (cohortID: number) => {
    this.setState({
      downloadCohortID: cohortID,
    });
    this.props.downloadCohortYaml(cohortID);
  }

  render() {
    return (
      <div>
        <ResourceGeneratorParams
          startGenerateResources={this.startGenerateResources}
          handleCohortNameChange={this.handleCohortNameChange}
          handleNumPaxChange={this.handleNumPaxChange}
          handleNumDaxChange={this.handleNumDaxChange}
          handleCityChange={this.handleCityChange}
          handleCohortTypeChange={this.handleCohortTypeChange}
          cohortType={this.state.cohortType}
          fillCities={this.fillCity}
          errors={this.props.generateResourcesErrors}
          resetErrorState={this.props.resetErrorState}
        />
        <ResourceGeneratorOutput
          cohortStatus={this.props.cohortStatus}
          downloadCohortYaml={cohortID => this.downloadCohortYaml(cohortID)}
        />

      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    resultantCohortIDs: state.app.resultantCohortIDs,
    generateResourcesErrors: _.get(state.errors, 'generateResources.errors', {}),
    cohortStatus: state.app.cohortStatus,
    cohortYamlFile: state.app.cohortYamlFile,
  };
}

export default connect(
  mapStateToProps,
  {
    generateResources,
    resetErrorState,
    resetResultantCohorts,
    downloadCohortYaml,
  }
)(ResourceGeneratorContainer);



/** WEBPACK FOOTER **
 ** ./src/js/views/resource_generator/ResourceGeneratorContainer.jsx
 **/